import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

// Actions
import { SetUser } from './user.actions';

// Models
import { UserStateModel } from '@app/models/user.model';

@State<UserStateModel>({
  name: 'user',
  defaults: {
    userId: '',
    email: '',
    firstName: '',
    lastName: '',
    fullName: '',
  },
})
@Injectable()
export class UserState {
  @Selector()
  static getUser(state: UserStateModel): UserStateModel {
    return state;
  }

  @Action(SetUser)
  setUser(ctx: StateContext<UserStateModel>, { payload }: SetUser) {
    ctx.setState(payload);
  }
}
